import React from "react";
import HeaderPasos from "../../../componentsUI/estructura/headerPasos/headerPasos.js";
import "./TemplateGastos.css";

// Formularios
import FormularioGastos from "../formularioGasto/formGasto.js";
import ListaGastos from "../listaGastos/listaGastos.js";
import TemplateTotales from "../templateTotales/template/templateTotales.js";

const pasosCaja = [
  
  {
    id: "gastos",
    label: "Crear gasto",
    component: <FormularioGastos />,
  },

    {
    id: "lista",
    label: "Ver gastos",
    component:<ListaGastos />,
  }  ,{
    id: "totales",
    label: "Totales",
    component:<TemplateTotales />,
  },

];

export default function TemplateCaja() {
  return (
    <HeaderPasos
      titulo="Gastos"
      pasos={pasosCaja}
      pasoInicial="gastos"
    />
  );
}
